import { useEffect } from 'react';
import { notification } from 'antd';
import { useProjectData } from 'hooks/useProjectData';

type Headers = Record<string, string> | undefined;

export const InstancesDataFetch = ({
  dataAttributesQuery,
  headers,
  onFetchedData,
  schemaCollectionRefId,
}: {
  dataAttributesQuery: string;
  headers?: Headers;
  onFetchedData: (queryResult: any) => void;
  schemaCollectionRefId: string;
}) => {
  const { data: queryResults } = useProjectData(
    schemaCollectionRefId,
    dataAttributesQuery,
    undefined,
    headers,
    {
      onError: (error) => {
        notification.error({
          message: 'Failed to fetch data',
          description: error as string,
        });
      },
    }
  );

  useEffect(() => {
    if (queryResults) {
      onFetchedData(queryResults);
    }
  }, [queryResults]);

  return null;
};
